import { PageLink } from '../../../_start/layout/core';

export const employeeManagementSubmenu: Array<PageLink> = [
  {
    title: 'Personeel',
    path: '/employee-management/employees',
    isActive: true,
  },

  {
    title: 'Afdelingen',
    path: '/employee-management/departments',
    isActive: true,
  },
];
